module.exports = __webpack_public_path__ + "img/Alexandre Lacazette.a29d99de.png";